import * as React from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import { useEffect, useCallback, useState } from 'react';
import {
  Box,
} from "@mui/material";
import Menu from '@mui/material/Menu';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updatePlanning } from "../../actions/planning";
import { ReactComponent as Arrow } from "../../assets/images/arrow-right.svg";
import { makeStyles } from "@mui/styles";
import DialogManageWorkload from "./DialogManageWorkload";
import DialogChangeDetail from "./DialogChangeDetail";
import { ReactComponent as TrashIcon } from "../../assets/images/portfolio/trash-alt.svg";
import { ReactComponent as EditIcon } from "../../assets/images/edit.svg";

const useStyles = makeStyles({
  btn: {
    fontSize: "18px !important",
    lineHeight: "24.59px !important",
    textDecoration: "underline !important",
    '& > svg': {
      marginLeft: "10px",
      marginBottom: "-2px",
    }
  },
  fillBlack: {
    '& > path': {
      fill: '#404349'
    },
    '& g > path': {
      fill: '#404349'
    },
  },
});

const styles = {
  td: {
    fontSize: "18px",
    lineHeight: "24.59px",
    textDecoration: "underline",
    '& > svg': {
      marginLeft: "10px",
      marginBottom: "-2px",
    }
  },
  iconBox: {
    width: "18px",
    height: "18px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    marginRight: "9px"
  },
};

export default function MenuListPlanningAccumulate(props) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const classes = useStyles();
  const { data, rubricCat, itemIndex, row, add, id, onDel, onEdit, closeMenu,status } = props;
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const Planning = useSelector((state) => state.Planning);
  useEffect(() => {
    setOpen(false);
    status(false)
  }, [closeMenu]);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    status((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
    status(false)
  };
  const handleDel = (data) => {
    if (data === "del") {
      onDel(row)
    }
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
      status(false)
    } else if (event.key === 'Escape') {
      setOpen(false);
      status(false)
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const { t } = useTranslation()
  const onDeletePress = (evt) => {
    handleDel("del");
  }
  const adds = (value) => {
    add(value)
  };
  let editAcc = () => {
    onEdit();
  }
  return (
    <Stack direction="row" spacing={2}>
      <div>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          classes={{ root: classes.btn }}
        >
          {t('label.manage')} <Arrow />
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
          style={{ "z-index": "1" }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem onClick={editAcc}>
                      <Box style={styles.iconBox}>
                        <EditIcon class={`${classes.fillBlack}`} />
                      </Box>
                      {t('label.edit')}</MenuItem>
                    <MenuItem onClick={onDeletePress}>
                      <Box style={styles.iconBox} >
                        <TrashIcon />
                      </Box>
                      {t('label.delete')}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}